import { render, staticRenderFns } from "./AppModalNew.vue?vue&type=template&id=5ba839e3&scoped=true"
import script from "./AppModalNew.vue?vue&type=script&lang=js"
export * from "./AppModalNew.vue?vue&type=script&lang=js"
import style0 from "./AppModalNew.vue?vue&type=style&index=0&id=5ba839e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba839e3",
  null
  
)

export default component.exports